import { Component, OnDestroy, OnInit, inject } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { ShiveDialogService } from '../../../../../core/services/controls/shive-dialog.service';
import { AnnualVacationQuotaDialogComponent } from '../../../dialogs/annual-vacation-quota-dialog/annual-vacation-quota-dialog.component';
import { WorkingTimeDialogComponent } from '../../../dialogs/working-time-dialog/working-time-dialog.component';
import { UserService } from '../../../services/user.service';
import { filter } from 'rxjs/operators';
import { UserOperation } from '../../../../../core/enums/user-operation';
import { SubSink } from 'subsink';
import { WorkingTimeModel } from '../../../../../core/models/user/working-time.model';
import { AnnualVacationQuotaModel } from '../../../../../core/models/user/annual-vacation-quota.model';
import { AuthService } from '../../../../../auth/auth.service';
import { UserDataService } from '../../../state-and-data-handling/user-data.service';
import { FormControlNameRecord } from '../../../../../shared/data-types/form-types';

@Component({
  selector: 'app-user-profile-employment-data',
  templateUrl: './user-profile-employment-data.component.html',
  styleUrl: './user-profile-employment-data.component.scss',
  standalone: false,
})
export class UserProfileEmploymentDataComponent implements OnInit, OnDestroy {
  public employmentDataForm: FormGroup;
  public formControlNames: FormControlNameRecord = {
    EmployedSince: 'employedSince',
    WorkingHours: 'workingHours',
    Monday: 'monday',
    Tuesday: 'tuesday',
    Wednesday: 'wednesday',
    Thursday: 'thursday',
    Friday: 'friday',
    Saturday: 'saturday',
    Sunday: 'sunday',
  };
  private readonly formBuilder = inject(FormBuilder);
  private readonly shiveDialogService = inject(ShiveDialogService);
  private readonly userService = inject(UserService);
  private readonly authService = inject(AuthService);
  private readonly userDataService = inject(UserDataService);
  private readonly subs = new SubSink();

  ngOnInit(): void {
    this.employmentDataForm = this.formBuilder.group({
      [this.formControlNames.EmployedSince]: [],
    });
  }

  ngOnDestroy(): void {
    this.subs.unsubscribe();
  }

  public openWorkingTimeDialog(): void {
    const ref = this.shiveDialogService.open({
      content: WorkingTimeDialogComponent,
      width: 572,
      title: 'Arbeitszeiten bearbeiten',
    });

    const dialogComponent = ref.content.instance as WorkingTimeDialogComponent;
    dialogComponent.workingTimeHistory = [
      ...this.authService.getLoggedInUserClone().workingTimeEntries,
    ];

    this.subs.sink = ref.result
      .pipe(filter((dialogResult) => dialogResult !== UserOperation.Cancel))
      .subscribe((dialogResult) => {
        const workingTimeHistory = dialogResult as WorkingTimeModel[];
        const updatedUser = this.userService.overrideWorkingTimeEntries(
          workingTimeHistory,
          this.authService.getLoggedInUserClone(),
        );
        this.userDataService.updateUser(updatedUser);
      });
  }

  public openAnnualVacationQuotaDialog(): void {
    const ref = this.shiveDialogService.open({
      content: AnnualVacationQuotaDialogComponent,
      width: 572,
      title: 'Urlaubszeiten bearbeiten',
    });

    const dialogComponent = ref.content.instance as AnnualVacationQuotaDialogComponent;
    dialogComponent.annualVacationQuotaHistory = [
      ...this.authService.getLoggedInUserClone().annualVacationQuotaEntries,
    ];

    this.subs.sink = ref.result
      .pipe(filter((dialogResult) => dialogResult !== UserOperation.Cancel))
      .subscribe((dialogResult) => {
        const annualVacationQuotaHistory = dialogResult as AnnualVacationQuotaModel[];
        const updatedUser = this.userService.overrideAnnualVacationQuotaEntries(
          annualVacationQuotaHistory,
          this.authService.getLoggedInUserClone(),
        );
        this.userDataService.updateUser(updatedUser);
      });
  }
}
